<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Dear A. Jones,<br /><br />

    Unfortunately, we have to inform you that your UPS shipment with the number
    1Z 665 X56 03 1234 5784 could not be sent. The reason is an error in the
    registration of the package. Please log into your UPS account to verify the
    information. We apologize for the inconvenience.<br /><br /><br />

    With kind regards<br /><br />

    Your UPS Team<br /><br />

    Contact:<br />
    Universal Logistics Services Pvt. Ltd.<br />
    D-79 Clifton<br />
    Block 5<br />
    Cleveland<br /><br />

    Customer Services: +1(0)8956446878<br />
    Head office: +1(0)8536347787<br />
    Email: uscustsvc@ups.com
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
